import {
  OneColumnBlock as OneColumnBlockZDS,
  OneColumnBlockProps,
} from '@zapier/design-system';
import { RichTextHtml } from '../../RichTextHtml/RichTextHtml';
import { RichTextHTMLString } from '../types';

type Props = Omit<OneColumnBlockProps, 'backgroundColor'> & {
  background: OneColumnBlockProps['backgroundColor'];
  description: RichTextHTMLString;
};

export function OneColumnBlock({
  background,
  description,
  ...restProps
}: Props) {
  return (
    <OneColumnBlockZDS
      backgroundColor={background}
      description={<RichTextHtml html={description} />}
      {...restProps}
    />
  );
}
